import React, { useState, setState, useEffect } from "react";
import { forwardRef, useRef, useImperativeHandle } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

/*Profile Components*/
import ProfilesList from "./profileComponents/ProfileList";
import ProfileInfo from "./profileComponents/ProfileInfo";
import ProfileTabs from "./profileComponents/ProfileTabs";
import "./Profile.css";

function Profile(props) {
  const [profileId, setProfileId] = React.useState(0);
  const [profile, setProfile] = React.useState(0);

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      useState,
      "& .MuiTextField-root": {},
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControlLabel-root": {
        margin: "0",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
    tableContainer: {
      maxHeight: "100%", // Ajusta la altura según sea necesario
      overflowY: "auto",
    },
  }));
  const classes = useStyles();
  let history = useHistory();

  const requestProfile = () => {
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfile_GetInfo?idProfile=" +
      props.match.params.id;
    const timeout = setTimeout(() => {
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setProfile({ ...data, IdProfile: data.idProfile });
        }, 500);

      return () => clearTimeout(timeout);
    });
  };

  useEffect(() => {
    requestProfile();
  }, []);

  useEffect(() => {
    requestProfile();
  }, [props.match.params.id]);

  //subscribeToTimer((err, timestamp) => settimestamp(timestamp));

  function UpdateProfile(row) {
    let profileRequest = {
      IdProfile: row.idProfile,
      ProfileName: row.profileName,
      Notes: row.notes,
      AlternateProfile: row.alternateProfile,
      AlternateEnable: row.alternateEnable,
      PromotionPoints: row.promotionPoints,
      SL_IfBets: row.sL_IfBets,
      SL_AlwaysActionMLBTotals: row.sL_AlwaysActionMLBTotals,
      PL_MaxGames: row.pL_MaxGames,
      PL_AllowProps: row.pL_AllowProps,
      PL_AllowGolf: row.pL_AllowGolf,
      PL_AllowMatchUps: row.pL_AllowMatchUps,
      PL_NoListedPitchers: row.pL_NoListedPitchers,
      PL_Juice2TeamParlay: row.pL_Juice2TeamParlay,
      PL_TrueOddsOption: row.pL_TrueOddsOption,
      PL_MaxOdds: row.pL_MaxOdds,
      PL_MaxPayout: row.pL_MaxPayout,
      PL_MaxTeamBuyPoints: row.pL_MaxTeamBuyPoints,
      PL_MaxBuyPoints: row.pL_MaxBuyPoints,
      PL_AlwaysAction: row.pL_AlwaysAction,
      PL_AllowRunLineTotal: row.pL_AllowRunLineTotal,
      PL_AllowSpreadTotalHK: row.pL_AllowSpreadTotalHK,
      PL_AllowSpreadTotalSOC: row.pL_AllowSpreadTotalSOC,
      PL_TieLoses: row.pL_TieLoses,
      PL_ParlayFormula: row.pL_ParlayFormula,
      PL_AllowOpenPlays: row.pL_AllowOpenPlays,
      PL_OddsDefault: row.pL_OddsDefault,
      PL_LowerUseDefault: row.pL_LowerUseDefault,
      PL_MaxDogsSide: row.pL_MaxDogsSide,
      PL_MaxDogsTotal: row.pL_MaxDogsTotal,
      PL_MaxDogsMoney: row.pL_MaxDogsMoney,
      PL_UseMaxSumOdds: row.pL_UseMaxSumOdds,
      PL_MaxSumOdds: row.pL_MaxSumOdds,
      IL_MaxParlays: row.iL_MaxParlays,
      IL_MaxLevelParlays: row.iL_MaxLevelParlays,
      IL_MaxTeasers: row.iL_MaxTeasers,
      IL_MaxLevelTeasers: row.iL_MaxLevelTeasers,
      IL_MaxNumberSB: row.iL_MaxNumberSB,
      IL_AskAmount: row.iL_AskAmount,
      IL_AllowChildHigher: row.iL_AllowChildHigher,
      ILOddslimit: row.iL_Oddslimit,
      PC_PitcherChangeType: row.pC_PitcherChangeType,
      TL_OpenLose: row.tL_OpenLose,
      TL_TeaserCancel: row.tL_TeaserCancel,
      SG_CancelSide: row.sG_CancelSide,
      SG_CancelTotal: row.sG_CancelTotal,
      SG_CancelRunLine: row.sG_CancelRunLine,
      PC_SkipSide: row.pC_SkipSide,
      PC_SkipTotal: row.pC_SkipTotal,
      PC_SkipRunLine: row.pC_SkipRunLine,
      Soc_Hookups: row.soc_Hookups,
      Rev_AllowOpen: row.rev_AllowOpen,
      DuplicateBetsCheckLineChange: row.duplicateBetsCheckLineChange,
      DuplicateBetsCheckParlays: row.duplicateBetsCheckParlays,
      DuplicateBetsCheckTeasers: row.duplicateBetsCheckTeasers,
      DuplicateBetsCheckReverses: row.duplicateBetsCheckReverses,
      DuplicateBetsCheckIfbets: row.duplicateBetsCheckIfbets,
      DuplicateBetsCheckIfSBRev: row.duplicateBetsCheckIfSBRev,
      DuplicateBetsCheckParlaysSB: row.duplicateBetsCheckParlaysSB,
      DuplicateBetsCheckTeasersSB: row.duplicateBetsCheckTeasersSB,
      DuplicateBetsCheckSameParlay: row.duplicateBetsCheckSameParlay,
      DuplicateBetsCheckSameTeaser: row.duplicateBetsCheckSameTeaser,
      FPAllowBothSides: row.fPAllowBothSides,
      FPAllowDuplicatedBets: row.fPAllowDuplicatedBets,
      FPCheckOfficeFilters: row.fPCheckOfficeFilters,
      FPMaxFav: row.fPMaxFav,
      FPMaxPayout: row.fPMaxPayout,
      FPMaxTeams: row.fPMaxTeams,
      FPOddsLimit: row.fPOddsLimit,
      CLMaxWager: row.cLMaxWager,
      MLDog_Over: row.mLDog_Over,
      MLDog_Under: row.mLDog_Under,
      MLFav_Under: row.mLFav_Under,
      MLFav_Over: row.mLFav_Over,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Profile/PlayerProfile_Update",
      data: profileRequest,
    }).then((response) => {
      if (response.data === "-1") {
        alert("Data Successfully Updated");
      }
      requestProfile();
    });
  }

  const setCurrentProfile = (profile) => {
    setProfile({ ...profile, IdProfile: profile.idProfile });
    history.push('/profile/' + profile.idProfile);
  };
  return (
    <React.Fragment>
      {profile && (
        <>
          <div className="sticky top-0 flex-grow-0">
            <div className={classes.tableContainer}>
              <ProfilesList
                showLoading={props.showLoading}
                setProfile={setCurrentProfile}
              ></ProfilesList>
            </div>

          </div>
          <div className="flex-1 min-w-0 h-max">
            <Paper className={`${classes.root} flex flex-col gap-4`}>
              <div
                id="inputs"
                style={{
                  display:
                    "flex flex-col items-center justify-center text-center",
                }}
              >
                {true ? (
                  <ProfileInfo
                    Profile={profile}
                    UpdateProfile={UpdateProfile}
                  ></ProfileInfo>
                ) : (
                    <ProfileInfo
                      Profile={profile}
                      UpdateProfile={UpdateProfile}
                    ></ProfileInfo>
                  )}
              </div>

              <ProfileTabs
                AgentInfo={props.location}
                Profile={profile}
                UpdateProfile={UpdateProfile}
                showLoading={props.showLoading}
              ></ProfileTabs>
            </Paper>
          </div>
        </>
      )}
    </React.Fragment>
  );
}

export default forwardRef(Profile);
